// 拦截器最终返回res.data
import axios from "axios";
import { message } from "antd";
import store from "@/store";
import { setIsOpen, setUserInfo, setAvatar } from "@/store/modules/user";

const service = axios.create({
	// axios中请求配置有baseURL选项，表示请求URL公共部分
	baseURL: process.env.REACT_APP_API_AFFIX,
	// 超时
	timeout: 20000,
	withCredentials: true,
	responseType: "json",
	responseEncoding: "utf8",
});
// request拦截器
service.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem("token");
		if (token) {
			const refreshToken = localStorage.getItem("refreshToken");
			config.headers.Authorization = "Bearer " + token;
			config.headers["Refresh-Token"] = refreshToken;
		}
		config.headers["Accept-Language"] = localStorage.getItem("lang") || "en-US"
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// 响应拦截器
service.interceptors.response.use(
	res => {
		const code = res.data.code
		if (code === 200) {
			const rotatedToken = res.headers.authorization?.replace(/^Bearer\s+/i, '')
			const rotatedRefreshToken = res.headers.refreshtoken
			if (rotatedToken || rotatedRefreshToken) {
				store.dispatch(setUserInfo({
					token: rotatedToken || localStorage.getItem("token") || "",
					refreshToken: rotatedRefreshToken || localStorage.getItem("refreshToken") || "",
				}))
			}
			return res.data
		} else if (res.config.acceptedResponseCodes?.includes(code)) {
			return res.data
        } else if (code === 401 && res.config.downloadAuthorization) {
            store.dispatch(setIsOpen(true));
            return Promise.reject(res.data);
		} else if (code === 401) {
			// message.error("登录已过期，请重新登录")
			message.error("loginerror")

			//  打开登录弹窗
		} else {
			message.error(res.data.msg)
		}
		return Promise.reject(res.data.msg);
	},
	(error) => {
		const msg = error?.response?.data?.msg;
        if (error.response?.status === 401 && error.config?.downloadAuthorization) {
            store.dispatch(setIsOpen(true));
            return Promise.reject(error);
        }
		if (error.response?.status === 401) {
			store.dispatch(setIsOpen(true));
			store.dispatch(setUserInfo({
				username: '',
				token: '',
				refreshToken: '',
				roleId: "",
				password: "",
				nickname:"",
				uuid:""
			}));
			store.dispatch(setAvatar(""));
			localStorage.clear()
		}
		message.error(msg);
		return Promise.reject(error);
	}
);
export default service;
